module.exports = __webpack_public_path__ + "static/media/resume.5333d6b5.pdf";